var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDashedCircleOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons / 18 / Outline / State",
    clipPath: "url(#clip0_36149_72423)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.38661 0.387788C8.18617 -0.158291 10.1116 -0.126938 11.8924 0.477444C13.6732 1.08183 15.22 2.22887 16.3155 3.75747C17.4109 5.28606 18 7.11941 18 9H15.6522C15.6522 7.61 15.2168 6.25492 14.4071 5.12508C13.5974 3.99525 12.4541 3.14744 11.1379 2.70072C9.82161 2.254 8.39847 2.23083 7.06837 2.63445C5.73826 3.03808 4.568 3.84822 3.72196 4.95109L1.85912 3.52206C3.00376 2.02994 4.58705 0.933868 6.38661 0.387788Z",
    fill: "var(--secondary-7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.276191 11.2125C-0.102119 9.72084 -0.0916264 8.15708 0.306668 6.67063L2.57449 7.27829C2.2801 8.37697 2.27235 9.53279 2.55197 10.6353C2.83159 11.7379 3.38924 12.7503 4.17166 13.5759L2.46754 15.1909C1.40898 14.0739 0.654502 12.7042 0.276191 11.2125Z",
    fill: "var(--secondary-7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99676 17.4841C8.04826 18.2103 10.2934 18.1686 12.3165 17.3667C14.3396 16.5647 16.0036 15.0569 17.0004 13.1223L14.9133 12.0469C14.1766 13.4768 12.9467 14.5913 11.4513 15.184C9.95601 15.7768 8.29655 15.8076 6.78022 15.2709L5.99676 17.4841Z",
    fill: "var(--secondary-7)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36149_72423"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "var(--white)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashedCircleOutlined);
export default __webpack_public_path__ + "static/media/dashedCircleOutlined.8058c92e94d97194af5edaafd6bb879f.svg";
export { ForwardRef as ReactComponent };